/* Toasts action types */
export const HIDE_TOAST = 'HIDE_TOAST';
export const SHOW_TOAST = 'SHOW_TOAST';
export const SHOW_BACKDROP = 'SHOW_BACKDROP';
export const HIDE_BACKDROP = 'HIDE_BACKDROP';

/* Filters */
export const SET_PAGE_FILTER = 'SET_PAGE_FILTER';

/* Data Definition Panel Actions */
export const TOGGLE_DD_PANEL_OPEN = 'TOGGLE_DD_PANEL_OPEN';

/* Data Entity Selected in Accordion */
export const DATA_ENTITY_SELECTED = 'DATA_ENTITY_SELECTED';

/* View As */
export const SET_VIEW_AS_USER = 'SET_VIEW_AS_USER';
export const CLEAR_VIEW_AS_USER = 'CLEAR_VIEW_AS_USER';
export const SET_VISITED_MS_PAGE = 'SET_VISITED_MS_PAGE';
export const SET_IS_PRIVATE_CLOUD_READ_ONLY = 'SET_IS_PRIVATE_CLOUD_READ_ONLY';

export const VIEW_MOCK_SERVICES = 'VIEW_MOCK_SERVICES';
export const LOADING_MOCK_SERVICES_LIST = 'LOADING_MOCK_SERVICES_LIST';
export const UPDATE_MOCK_SERVICES_LIST_COUNT = 'UPDATE_MOCK_SERVICES_LIST_COUNT';
export const GET_LOC = 'GET_LOC';
export const VIEW_MOCK_SERVICE_TEMPLATES_LIST = 'VIEW_MOCK_SERVICE_TEMPLATES_LIST';
export const VIEW_LOCATION_LIST = 'VIEW_LOCATION_LIST';
export const VIEW_SERVICE_LIST = 'VIEW_SERVICE_LIST';
export const SWAP_DRAFT = 'SWAP_DRAFT';

export const UPDATE_MS_HITS = 'UPDATE_MS_HITS';
export const UPDATE_IS_MS_IN_WORKSPACE = 'UPDATE_IS_MS_IN_WORKSPACE';

/* Virtual Services */
export const DELETE_MOCK_SERVICE = 'DELETE_MOCK_SERVICE';
export const MOCK_SERVICE_CHANGED = 'MOCK_SERVICE_CHANGED';
export const MOCK_SERVICE_TOGGLE_EXPAND_ROW = 'MOCK_SERVICE_TOGGLE_EXPAND_ROW';
export const MOCK_SERVICE_EXPAND_ITEM = 'MOCK_SERVICE_EXPAND_ITEM';
export const MOCK_SERVICE_MAR_FILE_ASSET_CHANGED = 'MOCK_SERVICE_MAR_FILE_ASSET_CHANGED';
export const MOCK_SERVICE_TEMPLATE_CHANGED = 'MOCK_SERVICE_TEMPLATE_CHANGED';
export const MOCK_SERVICE_TRANSACTIONS_CHANGED = 'MOCK_SERVICE_TRANSACTIONS_CHANGED';
export const MOCK_SERVICE_TRANSACTION_CONTENT_CHANGED = 'MOCK_SERVICE_TRANSACTION_CONTENT_CHANGED';
export const MOCK_SERVICE_DETAIL_TAB_CHANGED = 'MOCK_SERVICE_DETAIL_TAB_CHANGED';
export const MOCK_SERVICE_PARAM_TAB_CHANGED = 'MOCK_SERVICE_PARAM_TAB_CHANGED';
export const MOCK_SERVICE_UPDATE_FILTER = 'MOCK_SERVICE_UPDATE_FILTER';
export const FILTER_MOCK_SERVICES = 'FILTER_MOCK_SERVICES';
export const MOCK_SERVICE_COLLAPSE_ALL = 'MOCK_SERVICE_COLLAPSE_ALL';
export const SHOW_UPGRADABLE_MOCK_SERVICES = 'SHOW_UPGRADABLE_MOCK_SERVICES';
export const TOGGLE_START_MOCKING_BANNER = 'TOGGLE_START_MOCKING_BANNER';
export const UPDATE_START_MOCKING_BANNER = 'UPDATE_START_MOCKING_BANNER';
export const SHOW_UPGRADE_DROPDOWN_LOADING = 'SHOW_UPGRADE_DROPDOWN_LOADING';
export const HIDE_UPGRADE_DROPDOWN_LOADING = 'HIDE_UPGRADE_DROPDOWN_LOADING';

export const OPEN_UPGRADE_MOCK_SERVICE_MODAL = 'OPEN_UPGRADE_MOCK_SERVICE_MODAL';
export const CLOSE_UPGRADE_MOCK_SERVICE_MODAL = 'CLOSE_UPGRADE_MOCK_SERVICE_MODAL';

/* Virtual Service templates */
export const MOCK_SERVICE_TEMPLATES_CREATE_BLANK = 'MOCK_SERVICE_TEMPLATES_CREATE_BLANK';
export const MOCK_SERVICE_TEMPLATES_DELETE = 'MOCK_SERVICE_TEMPLATES_DELETE';
export const MOCK_SERVICE_TEMPLATES_UPDATE = 'MOCK_SERVICE_TEMPLATES_UPDATE';
export const MOCK_SERVICE_TEMPLATES_COLLAPSE_ALL = 'MOCK_SERVICE_TEMPLATES_COLLAPSE_ALL';
export const SWAP_MOCK_SERVICE_TEMPLATE_DRAFT = 'MOCK_SERVICE_TEMPLATES_OVERRIDE';
export const MOCK_SERVICE_TEMPLATES_EXPAND_ITEM = 'MOCK_SERVICE_TEMPLATES_EXPAND_ITEM';
export const MOCK_SERVICE_TEMPLATES_UPDATE_BY_ID = 'MOCK_SERVICE_TEMPLATES_UPDATE_BY_ID';
export const MOCK_SERVICE_FETCH_TEMPLATES = 'MOCK_SERVICE_FETCH_TEMPLATES';
export const MOCK_SERVICE_TEMPLATES_SHOW_LOADING_INDICATOR = 'MOCK_SERVICE_TEMPLATES_SHOW_LOADING_INDICATOR';
export const MOCK_TEMPLATES_SET_SAVING_STATE = 'MOCK_TEMPLATES_SET_SAVING_STATE';
export const MOCK_SERVICE_TEMPLATES_CHANGE_ACTIVE_PAGE = 'MOCK_SERVICE_TEMPLATES_CHANGE_ACTIVE_PAGE';
export const MOCK_SERVICE_TEMPLATES_SERVICE_CREATION_STARTED = 'MOCK_SERVICE_TEMPLATES_SERVICE_CREATION_STARTED';
export const MOCK_SERVICE_TEMPLATES_SERVICE_CREATION_FINISHED = 'MOCK_SERVICE_TEMPLATES_SERVICE_CREATION_FINISHED';
export const MOCK_SERVICE_TEMPLATES_UPDATE_FILTER = 'MOCK_SERVICE_TEMPLATES_UPDATE_FILTER';

/* Virtual Service template detail */
export const TEMPLATE_DETAIL_UPDATE_ACTIVE_TAB = 'TEMPLATE_DETAIL_UPDATE_ACTIVE_TAB';
export const TEMPLATE_DETAIL_UPDATE_ACTIVE_PARAM_TAB = 'TEMPLATE_DETAIL_UPDATE_ACTIVE_PARAM_TAB';
export const TEMPLATE_DETAIL_PANE_IS_LOADING = 'TEMPLATE_DETAIL_PANE_IS_LOADING';
export const TEMPLATE_DETAIL_RESET_VIEW = 'TEMPLATE_DETAIL_RESET_VIEW';
export const TEMPLATE_DETAIL_RESET_SHUTTLE = 'TEMPLATE_DETAIL_RESET_SHUTTLE';
export const TEMPLATE_DETAIL_SET_ASSET_BUNDLE = 'TEMPLATE_DETAIL_SET_ASSET_BUNDLE';
export const TEMPLATE_UPDATE_SHUTTLE_TRANSACTIONS = 'TEMPLATE_UPDATE_SHUTTLE_TRANSACTIONS';
export const TEMPLATE_UPDATE_SHUTTLE_MOVE_IN_PROGRESS = 'TEMPLATE_UPDATE_SHUTTLE_MOVE_IN_PROGRESS';
export const TEMPLATE_UPDATE_SHUTTLE_ACTIVE_PAGE = 'TEMPLATE_UPDATE_SHUTTLE_ACTIVE_PAGE';
export const TEMPLATE_UPDATE_SHUTTLE_SORT = 'TEMPLATE_UPDATE_SHUTTLE_SORT';
export const TEMPLATE_UPDATE_SHOW_PRIORITY_MODAL = 'TEMPLATE_UPDATE_SHOW_PRIORITY_MODAL';
export const TEMPLATE_SHUTTLE_EXPAND_ITEM = 'TEMPLATE_SHUTTLE_EXPAND_ITEM';
export const TEMPLATE_UPDATE_SHUTTLE_TRANSACTION_SELECTION = 'TEMPLATE_UPDATE_SHUTTLE_TRANSACTION_SELECTION';
export const TEMPLATE_UPDATE_SHUTTLE_TRANSACTION = 'TEMPLATE_UPDATE_SHUTTLE_TRANSACTION';
export const TEMPLATE_UPDATE_SHUTTLE_SEARCH_TERM = 'TEMPLATE_UPDATE_SHUTTLE_SEARCH_TERM';
export const TEMPLATE_UPDATE_RUNNER_TAB = 'TEMPLATE_UPDATE_RUNNER_TAB';
export const TEMPLATE_HTTP_RUNNER_UPDATE_TAB = 'TEMPLATE_HTTP_RUNNER_UPDATE_TAB';
export const TEMPLATE_MESSAGING_RUNNER_UPDATE_TAB = 'TEMPLATE_MESSAGING_RUNNER_UPDATE_TAB';
export const TEMPLATE_MESSAGING_RECORDED_UPDATE_TAB = 'TEMPLATE_MESSAGING_RECORDED_UPDATE_TAB';
export const TEMPLATE_RECORDING_SHUTTLE_UPDATE_PANE = 'TEMPLATE_RECORDING_SHUTTLE_UPDATE_PANE';
export const TEMPLATE_RECORDING_SHUTTLE_UPDATE_IN_PROGRESS = 'TEMPLATE_RECORDING_SHUTTLE_UPDATE_IN_PROGRESS';
export const TEMPLATE_MSG_CONFIG_SET_ACTIVE_TAB = 'TEMPLATE_MSG_CONFIG_SET_ACTIVE_TAB';

export const DEPLOY_MOCK_SERVICE = 'DEPLOY_MOCK_SERVICE';
export const STOP_MOCK_SERVICE = 'STOP_MOCK_SERVICE';
export const TOGGLE_IN_PROGRESS = 'TOGGLE_IN_PROGRESS';
export const SET_IN_PROGRESS = 'SET_IN_PROGRESS';
export const BULK_TOGGLE_IN_PROGRESS = 'BULK_TOGGLE_IN_PROGRESS';
export const BULK_STAGE_UPDATE = 'BULK_STAGE_UPDATE';
export const SAVE_OR_UPDATE_MOCK_SERVICE = 'SAVE_OR_UPDATE_MOCK_SERVICE';

/* Transactions */
export const GET_TRANSACTION_LIST = 'GET_TRANSACTION_LIST';
export const LOADING_TRANSACTION_LIST = 'LOADING_TRANSACTION_LIST';
export const GET_TRANSACTION = 'GET_TRANSACTION';
export const CLONE_TRANSACTION = 'CLONE_TRANSACTION';
export const SELECT_TRANSACTIONS = 'SELECT_TRANSACTIONS';
export const TRANSACTION_FILTER_CHANGED = 'TRANSACTION_FILTER_CHANGED';
export const FILTER_CLIENT_SIDE_TRANSACTIONS = 'FILTER_CLIENT_SIDE_TRANSACTIONS';
export const UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';
export const OPEN_HTTP_TRANSACTION_EDITOR_FOR_CREATE = 'OPEN_HTTP_TRANSACTION_EDITOR_FOR_CREATE';
export const OPEN_MSG_TRANSACTION_EDITOR_FOR_CREATE = 'OPEN_MSG_TRANSACTION_EDITOR_FOR_CREATE';
export const CLOSE_TRANSACTION_EDITOR_FOR_CREATE = 'CLOSE_TRANSACTION_EDITOR_FOR_CREATE';
export const SORT_TXN_TABLE = 'SORT_TXN_TABLE';
export const EXPAND_TRANSACTION_ROW = 'EXPAND_TRANSACTION_ROW';
export const UPDATE_ACTIVE_PAGE = 'UPDATE_ACTIVE_PAGE';
export const SET_TRANSACTION_PAGE_SIZE = 'SET_TRANSACTION_PAGE_SIZE';
export const BULK_TAG_TRANSACTION = 'BULK_TAG_TRANSACTION';
export const OPEN_TRANSACTION_BULK_TAG_MODAL = 'OPEN_TRANSACTION_BULK_TAG_MODAL';
export const CLOSE_TRANSACTION_BULK_TAG_MODAL = 'CLOSE_TRANSACTION_BULK_TAG_MODAL';
export const CHANGE_EDITOR_TAB = 'CHANGE_EDITOR_TAB';
export const RESET_TRANSACTIONS_SELECTION = 'RESET_TRANSACTIONS_SELECTION';

/*   MAR FILES    */
export const MAR_FILES_TOGGLE_EXPAND_ROW = 'MAR_FILES_TOGGLE_EXPAND_ROW';

/* Blaze User Config */
export const UPDATE_CURRENT_USER_DATA = 'UPDATE_CURRENT_USER_DATA';
export const SWITCH_WORKSPACE = 'SWITCH_WORKSPACE';

/* Virtual services */
export const FETCH_SERVICES = 'FETCH_SERVICES';
export const CREATE_MOCK_SERVICE = 'CREATE_MOCK_SERVICE';
export const CREATE_MOCK_SERVICE_FROM_RECORDER = 'CREATE_MOCK_SERVICE_FROM_RECORDER';
export const GET_LOGS = 'GET_LOGS';
export const TOGGLE_LOADING_LOGS = 'TOGGLE_LOADING_LOGS';
export const SET_OPEN_WINDOW_ID = 'SET_OPEN_WINDOW_ID';

/* TransactionsDropzoneState actions */
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const APPEND_DSL_TO_ARRAY = 'APPEND_DSL_TO_ARRAY';
export const RESET_STORE_STATE = 'RESET_STORE_STATE';

/* Virtual Service Details actions */
export const SET_MOCK_SERVICE = 'SET_MOCK_SERVICE';
export const TOGGLE_SHOW_MORE = 'TOGGLE_SHOW_MORE';
export const RESET_MOCK_SERVICE_DETAIL = 'RESET_MOCK_SERVICE_DETAIL';
export const SET_ACTIVE_MESSAGING_TAB = 'SET_ACTIVE_MESSAGING_TAB';
export const UPDATE_SHUTTLE_TRANSACTIONS = 'UPDATE_SHUTTLE_TRANSACTIONS';
export const UPDATE_SHUTTLE_ACTIVE_PAGE = 'UPDATE_SHUTTLE_ACTIVE_PAGE';
export const UPDATE_SHOW_PRIORITY_MODAL = 'UPDATE_SHOW_PRIORITY_MODAL';
export const UPDATE_SHUTTLE_SORTING = 'UPDATE_SHUTTLE_SORTING';
export const UPDATE_SHUTTLE_SEARCH_TERM = 'UPDATE_SHUTTLE_SEARCH_TERM';
export const UPDATE_SHUTTLE_TRANSACTION_SELECTION = 'UPDATE_SHUTTLE_TRANSACTION_SELECTION';
export const UPDATE_SHUTTLE_TRANSACTION = 'UPDATE_SHUTTLE_TRANSACTION';
export const RESET_SELECT_ALL = 'RESET_SELECT_ALL';
export const SET_ASSET_BUNDLE = 'SET_ASSET_BUNDLE';
export const SET_CERTIFICATES_IS_LOADING = 'SET_CERTIFICATES_IS_LOADING';
export const UPDATE_SHUTTLE_MOVE_IN_PROGRESS = 'UPDATE_SHUTTLE_MOVE_IN_PROGRESS';
export const EXPAND_SHUTTLE_TXN_ITEM = 'EXPAND_SHUTTLE_TXN_ITEM';
export const RESET_TRANSACTION_SHUTTLE = 'RESET_TRANSACTION_SHUTTLE';
export const PANE_IS_LOADING = 'PANE_IS_LOADING';
export const UPDATE_TRANSACTION_PRIORITY = 'UPDATE_TRANSACTION_PRIORITY';
export const UPDATE_MS_TRANSACTION_FIELD = 'UPDATE_MS_TRANSACTION_FIELD';
export const UPDATE_RUNNER_TAB = 'UPDATE_RUNNER_TAB';
export const HTTP_RUNNER_UPDATE_TAB = 'HTTP_RUNNER_UPDATE_TAB';
export const MESSAGING_RUNNER_UPDATE_TAB = 'MESSAGING_RUNNER_UPDATE_TAB';
export const MESSAGING_RECORDED_UPDATE_TAB = 'MESSAGING_RECORDED_UPDATE_TAB';
export const MESSAGING_UPDATE_RECORDED_MESSAGES = 'MESSAGING_UPDATE_RECORDED_MESSAGES';
export const MESSAGING_UPDATE_POLLING_STATUS = 'MESSAGING_UPDATE_POLLING_STATUS';
export const MESSAGING_UPDATE_RECORDING_NAME = 'MESSAGING_UPDATE_RECORDING_NAME';
export const RECORDING_SHUTTLE_UPDATE_PANE = 'RECORDING_SHUTTLE_UPDATE_PANE';
export const RECORDING_SHUTTLE_UPDATE_IN_PROGRESS = 'RECORDING_SHUTTLE_UPDATE_IN_PROGRESS';
export const RECORDING_SAVE_IN_PROGRESS = 'RECORDING_SAVE_IN_PROGRESS';

export const HTTP_RECORDING_SAVE_IN_PROGRESS = 'HTTP_RECORDING_SAVE_IN_PROGRESS';
export const HTTP_UPDATE_RECORDED_MESSAGES = 'HTTP_UPDATE_RECORDED_MESSAGES';
export const HTTP_UPDATE_POLLING_STATUS = 'HTTP_UPDATE_POLLING_STATUS';

/* Asset actions */
export const VIEW_MAR_FILES = 'VIEW_MAR_FILES';
export const DUPLICATE_ASSET_DETECTED = 'DUPLICATE_ASSET_DETECTED';
export const LOADING_MAR_FILES_LIST = 'LOADING_MAR_FILES_LIST';
export const ASSET_FILTER_CHANGED = 'ASSET_FILTER_CHANGED';
export const DELETE_MAR_FILE = 'DELETE_MAR_FILE';
export const DOWNLOAD_MAR_FILE = 'DOWNLOAD_MAR_FILE';

/* Sandbox */
export const SANDBOX_SET_PENDING = 'SANDBOX_SET_PENDING';
export const SANDBOX_OPEN = 'SANDBOX_OPEN';
export const SANDBOX_CLOSE = 'SANDBOX_CLOSE';
